import {
  Compass,
  Layers,
  ClipboardCheck,
  ShieldCheck,
  GitBranch,
  Activity,
  Check,
} from "lucide-react";
import { useI18n } from "../i18n/i18n";

const ICONS = [Compass, Layers, ClipboardCheck, ShieldCheck, GitBranch, Activity];

export default function Services() {
  const { t } = useI18n();
  const items = t("services.items");

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mb-16">
          <p className="cs-overline mb-4">{t("services.overline")}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            {t("services.title")}
          </h2>
          <p className="text-slate-400 mt-5 text-base lg:text-lg leading-relaxed">
            {t("services.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                className="cs-card p-7 flex flex-col"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="h-11 w-11 rounded-lg bg-sky-400/10 border border-sky-400/30 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-sky-400" strokeWidth={1.6} />
                  </div>
                  <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-400/90">
                    {item.tag}
                  </span>
                </div>

                <h3 className="font-display text-xl text-white leading-snug">
                  {item.title}
                </h3>
                <p className="text-slate-400 text-sm mt-3 leading-relaxed">
                  {item.desc}
                </p>

                <ul className="mt-6 space-y-2">
                  {item.points.map((p, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-sm text-slate-300"
                    >
                      <Check className="w-4 h-4 text-sky-400 mt-0.5 shrink-0" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
